import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_LAW_TASKS = 'GET_LAW_TASKS';
export const GET_LAW_TASK = 'GET_LAW_TASK';
export const CREATE_LAW_TASK = 'CREATE_LAW_TASK';
export const UPDATE_LAW_TASK = 'UPDATE_LAW_TASK';
export const DELETE_LAW_TASK = 'DELETE_LAW_TASK';

// Get all tasks
export const getLawTasks = (caseId, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchLawTasks(caseId, page, pageSize);

    dispatch({
      type: GET_LAW_TASKS,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching tasks:', error);
    throw error;
  }
};

// Get single task
export const getLawTask = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchLawTask(id);

    dispatch({
      type: GET_LAW_TASK,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching task:', error);
    throw error;
  }
};

// Create task
export const createLawTask = (taskData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createLawTask(taskData);

    dispatch({
      type: CREATE_LAW_TASK,
      payload: data
    });

    openSnackbar('Task created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Task created successfully"));

    return data;
  } catch (error) {
    console.error('Error creating task:', error);
    openSnackbar('Error creating task', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating task"));
    throw error;
  }
};

// Update task
export const updateLawTask = (id, taskData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateLawTask(id, taskData);

    dispatch({
      type: UPDATE_LAW_TASK,
      payload: data
    });

    openSnackbar('Task updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Task updated successfully"));

    return data;
  } catch (error) {
    console.error('Error updating task:', error);
    openSnackbar('Error updating task', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating task"));
    throw error;
  }
};

// Delete task
export const deleteLawTask = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteLawTask(id);

    dispatch({
      type: DELETE_LAW_TASK,
      payload: id
    });

    openSnackbar('Task deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Task deleted successfully"));
  } catch (error) {
    console.error('Error deleting task:', error);
    openSnackbar('Error deleting task', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting task"));
    throw error;
  }
};
